// Free-text version input for the manual publish path. Hidden behind a
// "Show advanced" disclosure in the parent — manual mode exists for the
// case where the catalog cron is dead or the operator needs to publish a
// version that hasn't been mirrored yet, and we want to discourage it for
// the common path.

import {
	Field,
	FieldDescription,
	FieldError,
	FieldLabel,
} from "@veil/ui/components/field";
import { Input } from "@veil/ui/components/input";
import type { FieldErrors, UseFormRegister } from "react-hook-form";

interface FormShape {
	mode: "latest" | "catalog" | "manual";
	version?: string;
}

interface Props {
	register: UseFormRegister<FormShape>;
	errors: FieldErrors<FormShape>;
}

export function ManualVersionInput({ register, errors }: Props) {
	const versionError = errors.version;
	return (
		<Field data-invalid={!!versionError}>
			<FieldLabel htmlFor="version">Full version</FieldLabel>
			<Input
				id="version"
				autoFocus
				placeholder="147.0.7727.139"
				aria-invalid={!!versionError}
				{...register("version")}
			/>
			<FieldDescription>Format: major.minor.build.patch</FieldDescription>
			<FieldError errors={[versionError]} />
		</Field>
	);
}
